import {
  Box,
  Heading,
  HStack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Tr,
} from "@chakra-ui/react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import MainModel from "../../../../components/Models/main-model";
import { closeShowSubjectAdminDataModel } from "../../../../modules/admin-modules/models/Actions";

const ShowSubjectAdminData = ({ data }) => {
  const openSubjectAdminData = useSelector((state) => state.model.isOpen37);
  const dispatch = useDispatch();
  const header = (
    <Box>
      <Heading textAlign="center" color="main_1" fontSize="24px">
        بيانات مادة المسؤول
      </Heading>
    </Box>
  );

  const closeFunc = () => {
    dispatch(closeShowSubjectAdminDataModel());
  };
  return (
    <MainModel header={header} closeFunc={closeFunc} openVar={openSubjectAdminData}>
      <TableContainer>
        <Table variant="striped" dir="rtl">
          <Tbody>
            <Tr>
              <Td>اسم المادة</Td>
              <Td>{data?.name}</Td>
            </Tr>
            <Tr>
              <Td>رقم الموبايل</Td>
              <Td>{data?.phone}</Td>
            </Tr>
            <Tr>
              <Td>الصف</Td>
              <Td>{data?.grade?.name}</Td>
            </Tr>
            <Tr>
              <Td>كلمة المرور</Td>
              <Td>{data?.password}</Td>
            </Tr>
          </Tbody>
        </Table>
      </TableContainer>
    </MainModel>
  );
};

export default ShowSubjectAdminData; 